<section class="creation-form">
  <button
    *ngIf="!isCreationMode"
    (click)="onEdit()"
    [matTooltip]="'repository.addressGroups.list.add' | translate"
    mat-mini-fab
    class="action-button"
    color="primary"
  >
    <mat-icon aria-label="Add">add</mat-icon>
  </button>
  <app-address-group-edit
    *ngIf="isCreationMode && !editedId"
    [addresses]="addresses"
    [sites]="sites"
    [siteGroups]="siteGroups"
    (editFinished)="onEditFinished()"
  ></app-address-group-edit>
</section>

<mat-form-field class="filterField">
  <mat-label>{{ "repository.addressGroups.filter" | translate }}</mat-label>
  <input matInput (keyup)="applyFilter($event)" placeholder="Votre filtre" />
</mat-form-field>

<section class="datatable-container">
  <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "repository.addressGroups.list.name" | translate }}
      </th>
      <td mat-cell *matCellDef="let group"><strong>{{ group.name }}</strong></td>
    </ng-container>

    <ng-container matColumnDef="addresses">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "repository.addressGroups.list.addresses" | translate }}
      </th>
      <td mat-cell *matCellDef="let group">
        <ul>
          <li *ngFor="let address of getVisibleAddresses(group)">
            {{ address.name }}
          </li>
          <li *ngIf="getRemainingAddressesCount(group) > 0">
            <button mat-button color="primary" class="show-more-items" type="button" (click)="toggleAddresses(group)">
              {{
                isAddressesExpanded(group)
                  ? ("repository.addressGroups.list.reduce" | translate)
                  : ("repository.addressGroups.list.others" | translate: { count: getRemainingAddressesCount(group) })
              }}
            </button>
          </li>
        </ul>
      </td>
    </ng-container>

    <ng-container matColumnDef="sites">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "repository.addressGroups.list.sites" | translate }}
      </th>
      <td mat-cell *matCellDef="let group">
        <ul class="item-list">
          <li
            *ngFor="let linkedSite of getVisibleLinkedSites(group)"
            class="item-chip"
            [ngClass]="linkedSite.type === 'siteGroup' ? 'site-group-chip' : 'site-chip'"
          >
            <span>{{ linkedSite.name }}</span>
            <small *ngIf="linkedSite.type === 'siteGroup'" class="group-badge">
              {{ "repository.addressGroups.list.siteGroup" | translate }}
            </small>
          </li>
          <li *ngIf="getRemainingLinkedSitesCount(group) > 0">
            <button mat-button color="primary" class="show-more-items" type="button" (click)="toggleLinkedSites(group)">
              {{
                isLinkedSitesExpanded(group)
                  ? ("repository.addressGroups.list.reduce" | translate)
                  : ("repository.addressGroups.list.others" | translate: { count: getRemainingLinkedSitesCount(group) })
              }}
            </button>
          </li>
        </ul>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        {{ "repository.addressGroups.list.actions" | translate }}
      </th>
      <td mat-cell *matCellDef="let group">
        <ng-container *ngIf="group.id !== editedId">
          <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading" [matTooltip]="'repository.addressGroups.list.edit' | translate" (click)="onEdit(group.id)">
            <mat-icon aria-label="Edit">edit</mat-icon>
          </button>
        </ng-container>
        <button mat-icon-button class="action-button" color="primary" [disabled]="isLoading" [matTooltip]="'repository.addressGroups.list.delete' | translate" (click)="delete(group.id)">
          <mat-icon aria-label="Delete">delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let group" [attr.colspan]="displayedColumns.length">
        <div *ngIf="group.id === editedId" class="row-edit" [@detailExpand]="group.id === editedId ? 'expanded' : 'collapsed'">
          <app-address-group-edit
            [addressGroup]="group"
            [addresses]="addresses"
            [sites]="sites"
            [siteGroups]="siteGroups"
            (editFinished)="onEditFinished()"
          ></app-address-group-edit>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="row" [ngClass]="{ 'expanded-row': row.id === editedId }"></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
  </table>
  <mat-paginator class="paginator" [pageSizeOptions]="[20, 25, 50, 100]" showFirstLastButtons></mat-paginator>
</section>
<mat-progress-bar *ngIf="isLoading" class="progress-bar" mode="indeterminate" color="primary"></mat-progress-bar>
